import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { cn } from '@/utils/utils';

const NotFoundPage: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 py-12 text-center">
            <div className="bg-white border border-gray-200 rounded-xl shadow-md p-8 max-w-md w-full">
                <div className="flex justify-center mb-4">
                    <div className="bg-primary-100 text-primary-600 rounded-full p-4">
                        <AlertTriangle className="w-8 h-8" />
                    </div>
                </div>

                <h1 className="text-2xl font-bold text-gray-800 mb-2">Página no encontrada</h1>
                <p className="text-gray-600 mb-6">
                    Lo sentimos, no pudimos encontrar la página que estás buscando.
                </p>

                <Link
                    to="/"
                    className={cn(
                        'inline-block bg-primary-600 text-white px-6 py-2 rounded-lg hover:bg-primary-700 transition-colors'
                    )}
                >
                    Volver al inicio
                </Link>
            </div>

            <p className="mt-8 text-sm text-gray-400">© {new Date().getFullYear()} Eisgemi</p>
        </div>
    );
};

export default NotFoundPage;
